(() => {
  // Play the approved packing upload at its original speed with its supplied audio.
  const editedAsset = 'd6a3340a86264044bc9486b314b24945';
  const originalAssets = ['45cb94cdc54a43baa9f847bae462d008', '4a77816c6e14497c81e329dd909915fc'];
  const initialized = new WeakSet();
  function configure(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    const sources = [video.currentSrc, video.src, ...Array.from(video.querySelectorAll('source'), source => source.src)];
    const edited = video.hasAttribute('data-rr-lesson') || sources.some(url => url && url.includes(editedAsset));
    const packing = edited || video.matches('[data-play-video="pack"]') ||
      video.closest('.rr-value__packing-video, #rr-setup') ||
      sources.some(url => url && originalAssets.some(asset => url.includes(asset)));
    if (!packing) return;
    video.defaultPlaybackRate = edited ? 1 : 2;
    video.playbackRate = video.defaultPlaybackRate;
    video.preservesPitch = true;
    initialized.add(video);
  }
  function scan(scope) {
    scope.querySelectorAll('video').forEach(configure);
  }
  scan(document);
  document.addEventListener('loadedmetadata', event => configure(event.target), true);
  document.addEventListener('play', event => {
    if (!initialized.has(event.target)) configure(event.target);
  }, true);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

